import { render, staticRenderFns } from "./CardResultFail.vue?vue&type=template&id=3028380a&scoped=true&"
import script from "./CardResultFail.vue?vue&type=script&lang=js&"
export * from "./CardResultFail.vue?vue&type=script&lang=js&"
import style0 from "./CardResultFail.vue?vue&type=style&index=0&id=3028380a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028380a",
  null
  
)

export default component.exports